import {call, put, delay} from 'redux-saga/effects';
import AuthActions from '../redux/AuthRedux';
import UserProfileActions from '../redux/UserProfileRedux';
import MessagesActions from '../redux/MessagesRedux';
import i18n from 'i18next';

const ACCESS_TOKEN_STORAGE_KEY = 'accessToken';
const REFRESH_TOKEN_STORAGE_KEY = 'refreshToken';

export function * login(authApi, api, action) {

  const response = yield call(authApi.login, {...action});

  if (response.ok) {
    const {access_token, refresh_token} = response.data;
    localStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, JSON.stringify(access_token));
    localStorage.setItem(REFRESH_TOKEN_STORAGE_KEY, JSON.stringify(refresh_token));

    yield call(authApi.setAuthToken, access_token);
    yield call(api.setAuthToken, access_token);
    yield put(AuthActions.loginSuccess(access_token));
    yield put(UserProfileActions.userProfileRequest());
  } else {
    const title = response.data && response.data[0] && response.data[0].errorMessage ? response.data[0].errorMessage : response.problem;
    yield put(AuthActions.authFailure(title));
    yield put(MessagesActions.messagesShow({
      type: 'error',
      code: response.status,
      title: title === 'user or password incorrect' ? i18n.t('auth:Password can not be sent') : title
    }));
  }
}

export function * logout(authApi, api, action) {
  localStorage.clear();
  
  yield call(authApi.removeAuthToken);
  yield call(api.removeAuthToken);
  yield put(AuthActions.logoutSuccess());
  yield put({type: 'RESET'});
}

export function* refreshToken(authApi, api, action) {
  const refreshToken = JSON.parse(localStorage.getItem(REFRESH_TOKEN_STORAGE_KEY));

  if (refreshToken != null) {
    const response = yield call(authApi.refreshToken, refreshToken);

    if (response.ok) {
      const {access_token, refresh_token} = response.data;
      localStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, JSON.stringify(access_token));
      localStorage.setItem(REFRESH_TOKEN_STORAGE_KEY, JSON.stringify(refresh_token));

      yield call(api.setAuthToken, access_token);
      yield call(authApi.setAuthToken, access_token);
      yield put(AuthActions.loginSuccess(access_token));
      yield put(UserProfileActions.userProfileRequest());
    } else {
      // Нет возможности получить новый токен на базе refresh_token
      localStorage.clear();
      yield put(AuthActions.authFailure(response.data && response.data.title ? response.data.title : response.problem));
    }
  } else {
    // Нет токена для автостарта
    yield delay(500);
    localStorage.clear();
    yield put(AuthActions.authFailure(null))
  }

}

export function * rememberPassword(authApi, action) {
  const response = yield call(authApi.getNewPassword, action.phone);

  if (response.ok) {
    yield put(AuthActions.rememberPasswordSuccess(response.data));
  } else {
    const title = response.data && response.data[0] && response.data[0].errorMessage ? response.data[0].errorMessage : response.problem;
    yield put(AuthActions.authFailure(title));
    yield put(MessagesActions.messagesShow({
      type: 'error',
      code: response.status,
      title: i18n.t('auth:Password can not be sent'),
      text: i18n.t('auth:Password can not be sent')}));
  }
}